/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/shield': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 6c-2.206 0-4 1.795-4 4s1.794 4 4 4 4-1.795 4-4-1.794-4-4-4zm0 6a2 2 0 110-4 2 2 0 010 4z"/><path pid="1" d="M16 2H4L2 4v11l2 3h12l2-3V4l-2-2zm-6 13c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"/>'
  }
})
